import { render, staticRenderFns } from "./DetailCreateTable.vue?vue&type=template&id=b8a61b32&scoped=true"
import script from "./DetailCreateTable.vue?vue&type=script&lang=js"
export * from "./DetailCreateTable.vue?vue&type=script&lang=js"
import style0 from "./DetailCreateTable.vue?vue&type=style&index=0&id=b8a61b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a61b32",
  null
  
)

export default component.exports